/**
 * Loto-general-init.js
 * class LotoGeneralInit
 */


 class LotoGeneralInit {
     constructor() {};

     /**
      * page link event
      */
     static pageLinkEvent() {
    
        for(var i=0; i<5; i++) {
            if(document.getElementById('cont-pull-ul-'+(i+1))) {
                MyUtility.setElementStyle('cont-pull-ul-'+(i+1), 'display', 'none');
            };
        };
        let objList = [];
        for(let i=0; i<5; i++) {  objList.push( { idString: 'cont-pull-ul-'+(i+1), is: false } );  }
        objList.forEach( (val,ind) =>
            MyUtility.setElementEvent('cont-label-down-'+(ind+1), 'click', MyUtility.buttonDownBoxProcess( objList, ind ), false)
        );
        
        // コンテンツボタン  モバイル用
        for(var i=0; i<5; i++) {
            if(document.getElementById('cont-pull-ul-'+(i+1)+'-mov')) {
                MyUtility.setElementStyle('cont-pull-ul-'+(i+1)+'-mov', 'display', 'none');
            };
        };
        let objList_mov = [];
        for(let i=0; i<5; i++) {  objList_mov.push( { idString: 'cont-pull-ul-'+(i+1)+'-mov', is: false } );  };
        objList_mov.forEach( (val,ind) =>
            MyUtility.setElementEvent('cont-label-down-'+(ind+1)+'-mov', 'click', MyUtility.buttonDownBoxProcess( objList_mov, ind ), false)
        );
    };


    // skip scroll
    static addWindowScrollEvent() {

        window.onscroll = function(){
            //  スクロール値取得
            let offsetY = window.pageYOffset;

            if(offsetY>300) {
                document.getElementById('skipDiv').style['display'] = 'block';
            }else {
                document.getElementById('skipDiv').style['display'] = 'none';
            };
        };
        
        LotoGeneralInit.funcWindowSize()
        window.addEventListener("resize", LotoGeneralInit.funcWindowSize, false);

        MyUtility.setElementEvent( 'skipTop', 'click', LotoGeneralInit.skipeTop, false );
        MyUtility.setElementEvent( 'skipBottom', 'click', () => LotoGeneralInit.skipeBottom(), false );

    };
    // skip DOM 操作
    static funcWindowSize() {

        let width = window.innerWidth;

        if(width > 1200) {
            document.getElementById("skipDiv").style.right = (width-1100)/2-60+'px';
        }else if(width>500){
            document.getElementById("skipDiv").style.right = "20px";
        }else {
            document.getElementById("skipDiv").style.right = "10px";
            document.getElementById("skipDiv").style.bottom = "8px";
        };
        
    };
    static skipeTop() {

        const offsetY = window.pageYOffset;

        const range = offsetY > 2000 ? offsetY/20 :  100;

        var timer = window.setInterval( () => LotoGeneralInit.windowScroll( timer, true, range, 0), 12 );

        //  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
        var timer2 = window.setTimeout( () => window.clearInterval( timer ), 600);
    };
    static skipeBottom(idStr='footerTop', intv=11, isTopBottom='top', verticalAlignBottom=true) {

        const offsetY = window.pageYOffset;
        const windowH = window.innerHeight;

        const targetTop = offsetY+document.getElementById(idStr).getBoundingClientRect()[isTopBottom];

        const range = footerTop-offsetY > 2000 ? (footerTop-offsetY)/20 : 100;

        const end = verticalAlignBottom ? targetTop-windowH : targetTop-5;

        let timer = window.setInterval( () => LotoGeneralInit.windowScroll( timer, false, range, end ), intv );

        //  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
        var timer2 = window.setTimeout( () => window.clearInterval( timer ), 1000);

    };
    static windowScroll( timer, isUpDown, range, end) {

        let offsetY = window.pageYOffset;

        if(isUpDown) {
            if(end>=offsetY) {
                window.clearInterval( timer );
            }else {
                offsetY = offsetY-range < end ? end : offsetY-range;
                window.scroll(0, offsetY);
            };
        }else {
            if(end-20<=offsetY) {
                window.clearInterval(timer);
            }else {
                offsetY = offsetY+range > end ? end : offsetY+range;
                window.scroll(0, offsetY);
            };
        };
    };

 };